import { fetchSubmodel, createSubmodelElement } from '../../services/DppManagerService';
import { transportCarbonFootprint } from '../../sm-templates/CarbonFootprint';

// Helper function to extract the highest number from TransportCarbonFootprint idShorts
const getHighestNumber = (submodelElements) => {
  if (!Array.isArray(submodelElements)) {
    console.warn('submodelElements is not an array:', submodelElements);
    return 0;
  }

  const numbers = submodelElements
    .filter(item => item.idShort && item.idShort.startsWith('TransportCarbonFootprint'))
    .map(item => {
      const match = item.idShort.match(/(\d+)$/);
      return match ? parseInt(match[1], 10) : 0;
    })
    .filter(num => !isNaN(num));

  return numbers.length > 0 ? Math.max(...numbers) : 0;
};

// Helper function to update the template JSON with form data and new number
const updateTemplateJson = (template, data, newNumber) => {
  const updatedTemplate = JSON.parse(JSON.stringify(template)); // Deep copy

  // Update idShort and displayName with new number
  updatedTemplate.idShort = `TransportCarbonFootprint${newNumber}`;
  updatedTemplate.displayName = [
    { language: 'en', text: `Transport Carbon Footprint ${newNumber}` },
    { language: 'de', text: `Transport-CO2-Fußabdruck ${newNumber}` }
  ];

  // Update values in the value array
  updatedTemplate.value.forEach(item => {
    if (item.idShort === 'TCFCO2eq') {
      item.value = data.TCFCO2eq ? data.TCFCO2eq.toString() : '';
    } else if (item.idShort === 'TCFCalculationMethod') {
      item.value = data.TCFCalculationMethod || '';
    } else if (item.idShort === 'TCFQuantityOfMeasureForCalculation') {
      item.value = data.TCFQuantityOfMeasureForCalculation ? data.TCFQuantityOfMeasureForCalculation.toString() : '';
    } else if (item.idShort === 'TCFReferenceValueForCalculation') {
      item.value = data.TCFReferenceValueForCalculation || '';
    } else if (item.idShort === 'TCFProcessesForGreenhouseGasEmissionInATransportService') {
      item.value = data.TCFProcessesForGreenhouseGasEmissionInATransportService || '';
    } else if (item.idShort === 'TCFGoodsTransportAddressHandover' && item.value) {
      item.value.forEach(addressItem => {
        if (addressItem.idShort === 'Street') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.Street || '';
        } else if (addressItem.idShort === 'HouseNumber') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.HouseNumber || '';
        } else if (addressItem.idShort === 'ZipCode') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.ZipCode || '';
        } else if (addressItem.idShort === 'CityTown') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.CityTown || '';
        } else if (addressItem.idShort === 'Country') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.Country || '';
        } else if (addressItem.idShort === 'Latitude') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.Latitude || '';
        } else if (addressItem.idShort === 'Longitude') {
          addressItem.value = data.TCFGoodsTransportAddressHandover?.Longitude || '';
        }
      });
    } else if (item.idShort === 'TCFGoodsTransportAddressTakeover' && item.value) {
      item.value.forEach(addressItem => {
        if (addressItem.idShort === 'Street') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.Street || '';
        } else if (addressItem.idShort === 'HouseNumber') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.HouseNumber || '';
        } else if (addressItem.idShort === 'ZipCode') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.ZipCode || '';
        } else if (addressItem.idShort === 'CityTown') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.CityTown || '';
        } else if (addressItem.idShort === 'Country') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.Country || '';
        } else if (addressItem.idShort === 'Latitude') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.Latitude || '';
        } else if (addressItem.idShort === 'Longitude') {
          addressItem.value = data.TCFGoodsTransportAddressTakeover?.Longitude || '';
        }
      });
    } else if (item.idShort === 'PublicationDate') {
      item.value = new Date().toISOString().split('T')[0] || '';
    }
  });

  return updatedTemplate;
};

const CO2ConsumptionHandler = async ({ data, setError, setSuccess, smId }) => {
  try {
    if (!smId || !data) {
      throw new Error('Submodel ID and data are required');
    }

    // Fetch the submodel
    const submodel = await fetchSubmodel(smId);

    // Get the highest TransportCarbonFootprint number
    const highestNumber = getHighestNumber(submodel?.submodelElements);
    const newNumber = highestNumber + 1;

    // Update the template JSON with form data and new number
    const payload = updateTemplateJson(transportCarbonFootprint, data, newNumber);

    // Create the new submodel element
    await createSubmodelElement(smId, payload);

    const successMessage = <>
      {'Aktion erfolgreich.'}{' '}
      <a className="alert-link" href="#" onClick={() => window.location.reload()}>
        {'Seite neu laden um Änderungen zu sehen'}
      </a>
    </>;
    setSuccess(successMessage);

  } catch (err) {
    console.error('Failed to save CO2 consumption:', err);
    setError(err.message || 'Failed to save CO2 consumption.');
  }
};

export default CO2ConsumptionHandler;